<template>
  <svg class="adobe-logo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
	 viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve" :width="this.svgWidth">
      <g class="stage stage-1">
        <path class="st0 long" d="M60.56,14.27l30,71.46V14.27H60.56z"/>
        <path class="st0 long" d="M9.4,14.27v71.46l30-71.46L9.4,14.27z"/>
        <path class="st0 short" d="M36.6,71.52h14.21l5.69,14.21h12.58L50,40.66L36.6,71.52z"/>
      </g>
      <g class="stage stage-2">
        <path class="st2" d="M60.58,14.27l30,71.46V14.27H60.58z"/>
        <path class="st2" d="M9.42,14.27v71.46l30-71.46L9.42,14.27z"/>
        <path class="st2" d="M36.62,71.52h14.21l5.69,14.21H69.1L50.02,40.66L36.62,71.52z"/>
      </g>
      <g class="stage stage-3">
        <rect x="60.1" y="13.3" class="st3 sq top2" width="2" height="2"/>
        <rect x="38.4" y="13.3" class="st3 sq top" width="2" height="2"/>
        <rect x="49" y="39.7" class="st3 sq top2" width="2" height="2"/>

        <rect x="8.4" y="13.3" class="st3 sq left" width="2" height="2"/>
        <rect x="8.4" y="85.7" class="st3 sq left" width="2" height="2"/>
        <rect x="35.6" y="70.5" class="st3 sq left" width="2" height="2"/>

        <rect x="55.8" y="84.7" class="st3 sq bot" width="2" height="2"/>
        <rect x="68.1" y="84.7" class="st3 sq bot" width="2" height="2"/>
        <rect x="49.8" y="70.5" class="st3 sq bot2" width="2" height="2"/>

        <rect x="89.6" y="85.7" class="st3 sq right" width="2" height="2"/>
        <rect x="89.6" y="13.3" class="st3 sq right" width="2" height="2"/>
      </g>
  </svg>
</template>

<script>
    export default {
      name: 'AdobeLogo',
      props: [
        'svgWidth'
      ]
    }
</script>

<style lang="scss" scoped>
  $bez: cubic-bezier(0.13, 0.65, 0.28, 0.85);
  $stage2children: 15;
  $stage3children: 8;
  $stage2Delay: .09s;

  $stage1Dur: .55s;
  $stage2Dur: $stage1Dur + ($stage2children * $stage2Delay);
  $stage3Dur: $stage2Dur + ($stage3children * $stage2Delay);

  .st0 {
    fill              : none;
    stroke            : #fff;
    stroke-width      : 0.25;
    stroke-miterlimit : 10;
  }

  .st1 {
    fill              : none;
    stroke            : #E80037;
    stroke-width      : 1;
    stroke-miterlimit : 10;
  }

  .st2 {
    fill : #E80037;
  }

  .st3 {
    fill              : #E80037;
    stroke            : #E80037;
    stroke-width      : 1;
    stroke-miterlimit : 10;
  }

  .adobe-logo {

    .stage-1,
    .stage-3 {
      opacity: 1;
      transition: opacity .7s;
      transition-delay: 2.6s;
    }

    .stage-1 {

      path {
        transition: stroke-dashoffset 1.4s;
      }

      @for $i from 1 through 3 {
          path:nth-child(#{$i}) {
            transition-delay : $i * .30s;
          }
      }

      .short {
        stroke-dasharray: 130;
        stroke-dashoffset: 130;
      }

      .long {
        stroke-dasharray: 180;
        stroke-dashoffset: 180;
      }
    }

    .stage-3 {
      .sq {
        transition: transform $bez .6s, opacity $bez .2s;
        opacity: 0;

        &.top {
          transform: translateY(-15px);
        }

        &.top2 {
          transform: translateY(-5px);
        }

        &.bot {
          transform: translateY(15px);
        }

        &.bot2 {
          transform: translateY(5px);
        }

        &.left {
          transform: translateX(-10px);
        }

        &.right {
          transform: translateX(10px);
        }
      }
    }

    .stage-2 {
      transform: scale(1);
      transition: transform $bez 1s;
      transform-origin: 50% 50%;
      transition-delay: 2.3s;

      path {
        opacity: 0;
        transform: scale(1);
        transition: opacity 1s;
        transition-delay: 1.7s;
      }
    }

    &.logoLoaded {
      .stage-1,
      .stage-3 {
        opacity: 0;
      }

      .stage-1 {
        path {
          stroke-dashoffset: 0;
        }
      }

      .stage-3 {
        .sq {
          transform: translate(0px);
          opacity: 1;
        }
      }

      .stage-2 {
        transform-origin: 50% 50%;
        transform: scale(.85);

        path {
          opacity: 1;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/svg/AdobeLogo.vue